import React from 'react';
import { format } from 'date-fns';
import * as M from '../Modules';
import StaticCard from '../StaticCard';

function TodayGroup({ isRecalculatingMetrics = false, firstName = '', lastName = '' }) {
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  const welcomeTitle = fullName
    ? `Welcome back ${fullName}. Your priorities today.`
    : 'Welcome back. Your priorities today.';

  return (
    <section className="drm-final-group">
      <div className="drm-final-group-header">
        <h2 className="drm-final-group-title">{welcomeTitle}</h2>
        {isRecalculatingMetrics ? (
          <div className="drm-final-group-eyebrow drm-final-group-eyebrow--recalculating">
            <span className="drm-final-recalc-dot" aria-hidden="true" />
            Updating your metrics…
          </div>
        ) : (
          <div className="drm-final-group-eyebrow">{format(new Date(), 'EEEE, d MMMM')}</div>
        )}
      </div>
      <div className="drm-final-group-body drm-final-group-body--today">
        <StaticCard id="dynamic-insight-line" className="drm-final-card--bare drm-final-card--hero">
          <M.DynamicInsightLine density="md" />
        </StaticCard>
        <div className="drm-final-divider-h" />
        <div className="drm-final-kpi-row">
          <StaticCard id="cash-outstanding" className="drm-final-card--bare">
            <M.CashOutstandingKPI density="sm" />
          </StaticCard>
          <div className="drm-final-divider-v" />
          <StaticCard id="due-soon-kpi" className="drm-final-card--bare">
            <M.DueSoonKPI density="sm" />
          </StaticCard>
          <div className="drm-final-divider-v" />
          <StaticCard id="dso-kpi" className="drm-final-card--bare">
            <M.DsoKPI density="sm" />
          </StaticCard>
        </div>
      </div>
    </section>
  );
}

export default TodayGroup;
